import { ColDef } from "ag-grid-community";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "utils/Global";

export const useItemCurrentStockByBinLocationColumnDefs = () => {
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);

  const { t } = useTranslation();
  useEffect(() => {
    setColumnDefs([
      {
        field: "warehouse_unique_id",
        headerName: t("warehouse.unique_id"),
        filter: false,
        width: 242,
      },
      {
        field: "warehouse_name",
        headerName: t("warehouse.index"),
        filter: false,
        width: 242,
      },
      {
        field: "bin_name",
        headerName: t("warehouse.bin_location.index"),
        filter: false,
        width: 242,
      },
      {
        field: "stock_qty",
        headerName: t("inventory.item.stock_qty"),
        filter: false,
        width: 242,
        valueFormatter: (params) =>
          params.value ? formatNumber(params.value) : "",
      },
    ]);
  }, [t]);
  return columnDefs;
};
